import { useFontenehus } from "../context/FontenehusContext";

export const useFontenehusActions = () => {
  const { fontenehusList, setSelectedFontenehus } = useFontenehus();

  const selectFontenehus = (husId: number) => {
    const hus = fontenehusList.find((h) => h.id === husId);
    if (!hus) return;
    setSelectedFontenehus(hus);
    localStorage.setItem("selectedFontenehus", JSON.stringify(hus));
  };

  return { selectFontenehus };
};
